import { render, staticRenderFns } from "./recommendedAlternatives.vue?vue&type=template&id=0e10b201&scoped=true&"
import script from "./recommendedAlternatives.vue?vue&type=script&lang=js&"
export * from "./recommendedAlternatives.vue?vue&type=script&lang=js&"
import style0 from "./recommendedAlternatives.vue?vue&type=style&index=0&id=0e10b201&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e10b201",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/dvl/tthomsen/compiere-all/pharmanord2011/template/webapps/integrationtest/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e10b201')) {
      api.createRecord('0e10b201', component.options)
    } else {
      api.reload('0e10b201', component.options)
    }
    module.hot.accept("./recommendedAlternatives.vue?vue&type=template&id=0e10b201&scoped=true&", function () {
      api.rerender('0e10b201', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/recommendedAlternatives.vue"
export default component.exports